/** Empty/error state heights matching a vault table's loading rows: header plus N 44px rows. */
export const VAULT_TABLE_5_ROWS_HEIGHT = '259px'
export const VAULT_TABLE_10_ROWS_HEIGHT = '478px'
